import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-86" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto w-full max-w-4xl px-5 text-center md:px-8" data-id="element-87" data-mp="1o3dj01a9xtlv">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-xl bg-blue-50 ring-1 ring-blue-100" data-id="element-88" data-mp="2223kru81ghgk">
          <ShieldCheckIcon className="h-8 w-8 text-blue-600" aria-hidden="true" data-id="element-89" data-mp="1x54nx3wzpweo" />
        </span>

        <h2 className="mt-7 text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-90" data-mp="19f0m923d46qb">
          Garantie de 7 jours
        </h2>

        <p className="mt-6 text-lg text-slate-900 md:text-xl" data-id="element-91" data-mp="1j4tym5bbwpvm">
          Essayez le matériel pendant 7 jours. S’il ne correspond pas à vos attentes, vous pouvez
          demander un remboursement intégral dans le délai de garantie.
        </p>
        <p className="mt-4 text-slate-600" data-id="element-92" data-mp="qmey73yp5kga">Sans complication.</p>
      </div>
    </section>;
}